import React from 'react';
import ReactDOM from 'react-dom/client';

function Header(){
    return <div className="header"><h1>Refer  Eye  Glaucoma</h1></div>;

}
export default Header;